import React, { useContext, useState, useEffect } from 'react'
import { useHistory, NavLink } from 'react-router-dom'
import CustomTable from '@/product/components/molecules/CustomTable'
import SettingContext from '@/product/context/seller/setting/settingContext'
import AuthContext from '@/product/context/auth/authContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import DashboardLayout from '@/views/Dashboard/DashboardLayout'
import { useTranslation } from 'react-i18next'
import { Button, ListItem } from '@material-ui/core'
import InvoiceView from './MySubscriptionInvoiceView'

const MySubscriptionList = (props) => {
    const { user, isAuthenticated } = useContext(AuthContext)
    const [isLoading, setIsLoading] = useState(true)
    const {
        searchTableAction,
        searchTable,
        table_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseSetting,
    } = useContext(SettingContext)
    const { t } = useTranslation()
    const [tableBody, setTableBody] = useState([])
    const [data, setData] = useState([])
    const [manage, setManage] = useState({
        popup: false,
        id: 0,
        sid: 0,
        status: 'view',
    })
    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            count: 1,
            order: '',
            orderby: '',
            table: 'user_memberships',
            filters: {
                fields: {
                    value: user?.id ? user.id : null,
                    type: 'in',
                    field: 'usm.user_id',
                },
            },
            tableJoins: [
                {
                    baseTable: 'users',
                    // customTable: 'users',
                    joinType: 'inner',
                    baseJoinField: 'id',
                    connectJoinField: 'user_id',
                },
                {
                    baseTable: 'bidding_plan',
                    // customTable: 'users',
                    joinType: 'inner',
                    baseJoinField: 'type',
                    connectJoinField: 'membership',
                },
            ],
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTable(values)
        },
    })
    useEffect(() => {
        setIsLoading(true)
        if (user && user.id) {
            formik.values.filters.fields.value = user.id
            searchTable(formik.values, 'getReview')
        }
    }, [user?.id])

    const tablePeriodChange = (data) => {
        let periodDataChange = data.map((el) => {
            // if (el.bidding_plan_yearly_period == '30') {
            //     el.membership_period = 'month'
            // } else

            if (el.bidding_plan_yearly_period == '1825') {
                el.membership_period = 'five year'
            }
            if (el.bidding_plan_yearly_period == '365') {
                el.membership_period = 'yearly(Access+)'
            }

            if (el.bidding_plan_plan_name == '*Subscribe for 5 years and Save*') {
                el.bidding_plan_plan_name = 'TimeBidder Access+'
            }
            return el
        })
        return periodDataChange
    }
    useEffect(() => {
        if (table_data && table_data.records.length) {
            setTableBody(tablePeriodChange(table_data.records))
            setData(table_data)
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 600)
    }, [table_data])

    const toggleFullScreenPopup = (popup, id, sid) => {
        if (popup) {
            setManage({ popup, id, sid, status: 'view' })
        } else {
            setManage({ popup, id: 0, sid: 0 })
        }
    }
    const onClickView = (sid, id, type) => {
        toggleFullScreenPopup(true, id, sid)
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'visibility',
                clickType: 'view',
                onclick: onClickView,
                tooltipTitle: 'View Invoice',
            },
        ]
        return actionPush
    }
    const closeFunction = () => {
        searchTable(formik.values, 'getReview')
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: t('ID'),
        },
        {
            field: 'bidding_plan_plan_name',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: t('Plan'),
        },
        {
            field: 'membership_date',
            type: 'date',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: t('Start Date'),
        },
        {
            field: 'membership_enddate',
            type: 'date',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: t('End Date'),
        },
        {
            field: 'membership_period',
            type: 'capitalize',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: t('Period'),
        },
        {
            field: 'amount',
            type: 'price',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: t('Amount'),
        },
        {
            field: 'action',
            type: 'button',
            clickID: 'common_invoice',
            secondaryClickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: t('Action'),
            isMultiple: getMultipleAction(),
        },
    ]
    let tableActions = []
    return (
        <>
            <DashboardLayout title={'My Subscription Transactions'}>
                {(props.location.pathname === '/payments/transactions' ||
                    props.location.pathname === '/payments/saved_cards' ||
                    props.location.pathname === '/payments/sub_transactions' ||
                    props.location.pathname === '/payments/subscription') && (
                    <div className="auctionStatus">
                        <ListItem button>
                            <NavLink activeClassName="active" to="/payments/transactions">
                                Transactions
                            </NavLink>
                        </ListItem>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/payments/saved_cards">
                                Card Details
                            </NavLink>
                        </ListItem>

                        <ListItem button>
                            <NavLink activeClassName="active" to="/payments/subscription">
                                My Subscription
                            </NavLink>
                        </ListItem>

                        <ListItem button>
                            <NavLink activeClassName="active" to="/payments/sub_transactions">
                                My Subscription Transactions
                            </NavLink>
                        </ListItem>
                    </div>
                )}
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={data}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={searchTable}
                />
                <InvoiceView
                    data={manage}
                    array={tableBody}
                    function={toggleFullScreenPopup}
                    closeFunction={closeFunction}
                />
            </DashboardLayout>
        </>
    )
}

export default MySubscriptionList
